import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Button from "@material-ui/core/Button";

import { useStyles } from "../../../../../Components/CSS/TableStyle.css";
import AdminHeader from "../../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import PageTitle from "../../../../../Components/PageTitle/PageTitle";
import VehicleFilter from "../VehicleFilter/VehicleFilter";
import CustomTableHead from "../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import VehicleBody from "../VehicleBody/VehicleBody";
import CustomTableFooter from "../../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { connect } from "react-redux";
import CustomEmptyMessage from "../../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import CustomSiteLoader from "../../../../../Components/CustomSiteLoader/CustomSiteLoader";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import CustomBreadCrumbs from "../../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ViewVehicle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 5,
      page: 0,
      searchBy: {
        route: "",
      },
      column: [
        { name: "S.N" },
        { name: "Routes" },
        { name: "Vehicle Number" },
        { name: "Driver Name" },
        { name: "Assitant Driver Name" },
        { name: "Actions" },
      ],
      vehicles: [],
      isEmpty: false,
    };
  }

  componentDidMount() {
    this.getVehicles();
  }

  getVehicles = async () => {
    try {
      const response = await Axios.get(`${url}/api/vehicles`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.vehicles.length !== 0) {
        this.setState({
          vehicles: response.data.vehicles,
          isEmpty: false,
        });
      } else {
        this.setState({
          vehicles: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getVehicles();
      }
    }
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleSearch = (e) => {
    this.setState({
      searchBy: {
        ...this.state.searchBy,
        [e.target.name]: e.target.value,
      },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page } = this.state;
    const filtered = this.state.vehicles.filter((vehicle) => {
      return (
        vehicle.route
          .toLowerCase()
          .indexOf(this.state.searchBy.route.toLowerCase()) !== -1
      );
    });
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle
            title="Vehicle List"
            refreshUrl={this.props.match.url}
            addUrl={"/administration/vehicle/add"}
            urlTitle="Add Vehicle name"
          />

          {this.state.vehicles.length !== 0 && (
            <VehicleFilter
              data={this.state.searchBy}
              handleSearch={this.handleSearch}
            />
          )}

          {this.state.vehicles.length !== 0 && (
            <Button
              className={classes.buttonStyle}
              onClick={() =>
                this.props.history.push(`/administration/vehicle/manage`)
              }
            >
              Add Students to Vehicles
            </Button>
          )}
          {this.state.vehicles.length !== 0 ? (
            <TableContainer>
              <Table>
                <CustomTableHead column={this.state.column} />

                <TableBody>
                  {filtered
                    .slice(rowsPerPage * page, rowsPerPage * page + rowsPerPage)
                    .map((vechicleModel, index) => (
                      <VehicleBody
                        data={vechicleModel}
                        key={index}
                        index={index}
                        getVehicles={this.getVehicles}
                      />
                    ))}
                </TableBody>

                <CustomTableFooter
                  count={filtered.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={this.handlePage}
                  onChangeRowsPerPage={this.handleRowsPerPage}
                />
              </Table>
            </TableContainer>
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage />
          ) : (
            <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewVehicle)));
